import React, { Component } from "react";
import { connect } from "react-redux";
import T from "prop-types";
import { Field } from "redux-form";
import { get, isFunction } from "lodash";

import api from "APP_ROOT/api";
import { addressesToOptions } from "LIB/forms";
import {
  AutoCompleteField,
  Select,
  FormTypes as F,
  FormInput
} from "MODULES/shared/components/Forms";
import { fobFormat } from "LIB/formatters/address";
import * as actions from "MODULES/PurchaseOrders/actions";
import CompanyAddressWarning from "MODULES/shared/components/CompanyAddressWarning";
import { Col } from "react-bootstrap";
import FormRow from "MODULES/shared/components/Forms/FormRow";

class CompanyAddress extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedCompany: props.selectedCompany,
      addresses: [],
      invalidCompany: false
    };
  }

  componentWillMount() {
    const { selectedCompany } = this.state;
    const { companyId, addressId, onChangeShippingPreference } = this.props;
    this.mounted = true;

    if (selectedCompany) {
      this.fetchAddresses(selectedCompany.id, addressId.input.value, false);

      if (companyId.input.value !== selectedCompany.id) {
        companyId.input.onChange(selectedCompany.id);
      }

      if (onChangeShippingPreference && selectedCompany.id) {
        this.fetchShippingPreferences(selectedCompany.id);
      }
    }

    this.onChangeAddress(null);
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  onChangeAddress = address => {
    const { onChangeAddress } = this.props;

    if (isFunction(onChangeAddress)) {
      onChangeAddress(address);
    }
  };

  fetchAddresses = (companyId, primaryAddressIdValue, setFOB) =>
    companyId &&
    api.companies.physicalAddresses
      .search(companyId, {
        page: 1,
        limit: 100,
        sort: "primary",
        reverse: true
      })
      .then(({ data: { results } }) => {
        if (this.mounted) {
          const {
            addressId: { input },
            onChangeAddress,
            addressPh
          } = this.props;
          addressPh &&
            results[0].phone &&
            addressPh.input.onChange(results[0].phone);
          input.onChange(primaryAddressIdValue || results[0].id);

          if (results.length > 0) {
            input.onChange(primaryAddressIdValue || results[0].id);

            if (isFunction(onChangeAddress)) {
              onChangeAddress(results[0]);
            }

            this.setState({ addresses: results });
            return (
              setFOB && setFOB(fobFormat(primaryAddressIdValue || results[0]))
            );
          }
        }
        return null;
      });

  fetchShippingPreferences = companyId =>
    api.companies.shippingMethods
      .search(companyId, {
        page: 1,
        limit: 100
      })
      .then(({ data: { results } }) => {
        if (this.mounted) {
          const { onChangeShippingPreference } = this.props;

          if (results.length > 0) {
            if (isFunction(onChangeShippingPreference)) {
              onChangeShippingPreference(results[0]);
            }
          }
        }
        return null;
      });

  handleCompanySelected = result => {
    const { addressId, setFOB, addressPh } = this.props;

    addressId.input.onChange(null);
    this.onChangeAddress(null);
    addressPh &&
      addressPh.input.onChange(
        get(result, "primary_physical_address.phone") || result.phone
      );

    this.setState({
      selectedCompany: result,
      invalidCompany:
        !!result &&
        (!result.primary_physical_address || !result.billing_address)
    });

    if (result) {
      this.fetchAddresses(result.id, null, setFOB);
    }
  };

  render() {
    const {
      searchCompanies,
      companyId,
      addressId,
      addressPh,
      disabled,
      required = true
    } = this.props;
    const { addresses, selectedCompany, invalidCompany } = this.state;
    const companyIdInput = companyId.input;
    const addressIdInput = addressId.input;
    const addressPhInput = addressPh && addressPh.input;

    return (
      <div>
        {invalidCompany && <CompanyAddressWarning company={selectedCompany} />}
        <FormRow>
          <Col md={6}>
            <Field
              name={companyIdInput.name}
              label="Ship To Company Name"
              placeholder="Search by typing a company's name or code"
              component={AutoCompleteField}
              search={searchCompanies}
              formatItem={result => result && result.name}
              selectedItem={selectedCompany}
              onItemSelected={i => i && this.handleCompanySelected(i)}
              required={required}
              disabled={disabled}
            />
          </Col>
          <Col md={6}>
            <Field
              name={addressIdInput.name}
              label="Ship To Company Address"
              component={Select}
              options={addressesToOptions(addresses)}
              prompt={false}
              disabled={invalidCompany || disabled}
              required={required}
            />
          </Col>
        </FormRow>
        <FormRow>
          {addressPhInput && (
            <Col md={6}>
              <Field
                name={addressPhInput.name}
                label="Ship To Company Phone"
                component={FormInput}
              />
            </Col>
          )}
        </FormRow>
      </div>
    );
  }
}

CompanyAddress.propTypes = {
  addressId: F.formField(F.malleable).isRequired,
  companyId: F.formField(F.malleable).isRequired,
  addressPh: F.formField(F.malleable),
  required: T.bool,
  searchCompanies: T.func.isRequired,
  setFOB: T.func,
  onChangeAddress: T.func,
  selectedCompany: T.shape({
    id: T.number.isRequired
  }),
  disabled: T.bool
};

export default connect(undefined, dispatch => ({
  searchCompanies: filter => dispatch(actions.searchCompanies(filter))
}))(CompanyAddress);



// WEBPACK FOOTER //
// ./app/modules/Orders/shared/ShippingFields/CompanyAddress.jsx